"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRestrictedAccessTitle = exports.getRestrictedAccessSubtitle = exports.getRestrictedAccessButtonText = exports.getRestrictedAccessButtonHref = exports.getIsRestrictedAccess = void 0;

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var getIsRestrictedAccess = function getIsRestrictedAccess(variant) {
  return variant === 'restricted';
};

exports.getIsRestrictedAccess = getIsRestrictedAccess;

var getRestrictedAccessTitle = function getRestrictedAccessTitle(title, isRestrictedAccess) {
  return title || (isRestrictedAccess ? 'You don\'t have access to this page.' : 'You don\'t have access to this business.');
};

exports.getRestrictedAccessTitle = getRestrictedAccessTitle;

var getRestrictedAccessSubtitle = function getRestrictedAccessSubtitle(subtitle, isRestrictedAccess) {
  return subtitle || (isRestrictedAccess ? 'If you need access, contact an admin on your team to update your permissions.' : '');
};

exports.getRestrictedAccessSubtitle = getRestrictedAccessSubtitle;

var getRestrictedAccessButtonHref = function getRestrictedAccessButtonHref(isRestrictedAccess, spId) {
  return isRestrictedAccess ? _urlCatalog["default"].office.leads.homePage(Number(spId)) : _urlCatalog["default"].office.businessList();
};

exports.getRestrictedAccessButtonHref = getRestrictedAccessButtonHref;

var getRestrictedAccessButtonText = function getRestrictedAccessButtonText(buttonText) {
  return buttonText || 'Go to your business';
};

exports.getRestrictedAccessButtonText = getRestrictedAccessButtonText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/restrictedAccess/restrictedAccessUtills.js
// module id = 5171
// module chunks = 25